export default "__VITE_ASSET__x_KjgY6J__"